import script from "./BuyerDashboardRemunerationStackedBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerDashboardRemunerationStackedBarChart.vue?vue&type=script&setup=true&lang=js"

import "./BuyerDashboardRemunerationStackedBarChart.vue?vue&type=style&index=0&id=1ef0ad43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef0ad43"]])

export default __exports__